import { BillingApi, Configuration } from '@/api';
import { BillingCustomerTarget, BillingInfo } from '@/models/Billing';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export const getBillingInfoQueryKey = ['billing-info'];

const useGetBillingInfoQuery = (customer?: BillingCustomerTarget) => {
  const queryClient = useQueryClient();

  const billingApi = new BillingApi(new Configuration(useAuth));

  const {
    data: billingInfo,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery<BillingInfo | undefined>({
    queryKey: [getBillingInfoQueryKey[0], customer ?? null],
    queryFn: () => billingApi.getBillingInfo(customer),
  });

  const invalidateQuery = async () => {
    await queryClient.invalidateQueries({
      queryKey: [getBillingInfoQueryKey[0], customer ?? null],
    });
  };

  return {
    billingInfo,
    isLoading,
    isFetching,
    error,
    refetch,
    invalidateQuery,
  };
};

export default useGetBillingInfoQuery;
